export default "__VITE_ASSET__C9Xpzbf8__"